import Vue from 'vue';
import waitFor from 'p-wait-for';
import { registerMissionMap } from 'ocus-styleguide/src/components/missionMap/index';

export default async (ctx) => {
  registerMissionMap(ctx.$config);
  const $google = async () => {
    await waitFor(() => !!Vue.$gmapApiPromiseLazy);
    Vue.$gmapApiPromiseLazy();
    await waitFor(() => !!window.google);
    return window.google;
  };

  ctx.$google = $google;
  Vue.prototype.$google = $google;
};
